import AfterFetchComponent from '@/components/base/AfterFetchComponent'
import EditDocumentsComponents from "@/components/dashboard/loans-management/EditDocuments.vue";
import StatusesHistoryTableComponent from "@/components/dashboard/loans-management/StatusesHistoryTable.vue";
import AddingNewProcessModalContent from "@/components/dashboard/process-management/addingProcess/AddingNewProcessModalContent.vue";
import PersonalDetailsProcessManagementComponent
  from "@/components/dashboard/process-management/PersonalDetailsProcessManagement.vue";
import StatusesManagementProcessManagementComponent
  from "@/components/dashboard/process-management/StatusesManagementProcessManagement.vue";
import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";
import {messages} from "@/lang/heValidation";
import {ExportType} from '@payroll/grid-widget/src/models/ExportType'
import {GridColumn} from "@payroll/grid-widget/src/models/GridColumn";
import {BaseRequest, FileMimeType, KeyValuePair, Utils} from "@payroll/optimus-common";
import {FieldType, SearchFieldModel} from "@payroll/search-results-widget/src/models/SearchField.model";
import Component from 'vue-class-component'
import {Action} from "vuex-class";

@Component({components: {
    AddingNewProcessModalContent,
    StatusesHistoryTableComponent,
    PersonalDetailsProcessManagementComponent,
    StatusesManagementProcessManagementComponent,
    EditDocumentsComponents
  }})
export default class ProcessManagementComponent extends AfterFetchComponent {

  @Action('fetchProcessesManagementRequest', StoreNamespace.PROCESSES_MANAGEMENT) fetchProcessesManagementRequest: any
  @Action('processesManagementSettings', StoreNamespace.PROCESSES_MANAGEMENT) getProcessesManagementSettings: any
  @Action('downloadProcessesManagementApplication', StoreNamespace.PROCESSES_MANAGEMENT) downloadProcessesManagementApplication: any
  @Action('approveProcessApplications', StoreNamespace.PROCESSES_MANAGEMENT) approveProcessApplications: any
  @Action('exportProcessesManagementDetails', StoreNamespace.PROCESSES_MANAGEMENT) exportProcessesManagementDetails: any
  @Action('getUsersByProcessTypeCode', StoreNamespace.PROCESSES_MANAGEMENT) getUsersByProcessTypeCode: any
  @Action('updateRoutingUserProcessesManagement', StoreNamespace.PROCESSES_MANAGEMENT) updateRoutingUserProcessesManagement: any


  private searchLoansFields: SearchFieldModel[] = []
  private columns: GridColumn[] = []
  private ExportType = ExportType
  private checkBoxCheckAllProperty = false;
  private processOptions: KeyValuePair[] = [];
  private allUsers: KeyValuePair[] = [];
  private allStatusType: KeyValuePair[] = [];
  private archive: KeyValuePair[] = [];
  private withdrawalProcess: string[] = [];
  private gridData: any = [];
  private showSingleRequestDetailsPopup: boolean = false;
  private isMangingCompanyStatusChanged: boolean = false
  private rowSelected: any = {statusManagementDetailsFormData: {}}; // todo: loanApprovalDetailsFormData
  private tabIndex: number = 0;
  private DEFAULT_PAGE_SIZE: number = 10;
  private searchObject: any = {}
  private problemWithApplication: boolean = false;

  private showRemark: boolean = false;
  private showDontSendMassage: boolean = false
  private errorMessageAfterApprove: string = ""

  private styleGridTimeout: any = null;
  private loanStatusStyleMap: any = {
    0: "#0000ff",
    1: "#008000",
    2: "#008000",
    3: "#ee0000",
    4: "#9e6d14",
    5: "#090909",
  }
  private lastSearchObject: any = {}
  private userForRoutingList: KeyValuePair[] = []
  private inquiriesForAssociation: any = []
  private selectedUserForRouting: KeyValuePair | null = null
  private showRoutingContactsToUserPopup: boolean = false;
  private showNotSelectedInquiresPopup: boolean = false;
  private showNotFinalStatusPopup: boolean = false;
  private currentInquiries: any = []
  private showAddingNewProcessModal: boolean = false;

  created() {
    this.$on('successResults', (data: any, index: number) => {

      if (this.styleGridTimeout) {
        clearTimeout(this.styleGridTimeout)
      }

      this.styleGridTimeout = setTimeout(() => {
        for (const key in this.loanStatusStyleMap) {
          const loanStatus = this.allStatusType.find((ls: any) => ls.value == key);
          if (loanStatus) {
            $('td.requestStatus\\.description:contains("' + loanStatus.description + '")').css('color', this.loanStatusStyleMap[key]).css('font-size', '18px')
          }
        }
      }, 0)
    })
  }

  beforeDestroy() {
    if (this.styleGridTimeout) {
      clearTimeout(this.styleGridTimeout)
    }
  }

  mounted() {
    this.archive = [
      {value: "true", description: "כן"},
      {value: "false", description: "לא"}];

    this.initColumns();
    this.getProcessesManagementSettings({requestorCallback: this})
  }

  onSuccess(data ?: any, requestName ?: string, message ?: string, success ?: boolean): void {
    switch (requestName) {
      case 'fetchProcessesManagementRequest':
        this.gridData = data.results.map((result: any) => {
          return ({...result, statusManagementDetailsFormData: {} ,isCheckBoxSelected: false});
        })

        if (this.lastSearchObject.pageNumber === 0) {
          this.currentInquiries = [...this.gridData];
        } else {
          this.currentInquiries = [...this.currentInquiries, ...this.gridData]
        }

        this.$emit('successResults', {
          ...data, results: this.gridData
        })
        break

      case 'processesManagementSettings':
        this.allStatusType= data.statusOptions;
        this.processOptions= data.processOptions;
        this.allUsers = data.allUsers;
        this.withdrawalProcess = data.withdrawalProcess;
        this.initSearchFields();
        break

      case 'approveProcessApplications':
        this.afterManagingCompanySuccessUpdated()
        this.checkBoxCheckAllProperty = false
        this.showSuccessAction();
        break

      case 'downloadProcessesManagementApplication':
        Utils.downloadFile(data.fileData, data.fileName, FileMimeType.PDF)
        this.$emit('successExport', data)
        break

      case 'exportProcessesManagementDetails':
        data.fileExtension = 'xlsx'
        this.$emit('successExport', data)
        break

      case 'usersByProcessTypeCode':
        this.userForRoutingList = data.users
        break;

      case 'updateRoutingUserProcessesManagement':
        this.onClosePopup()
        this.showAfterSuccessfullyActionPopup("ניתוב הפניות בוצע בהצלחה")
        this.getGridData({
          ...this.searchObject
        });
    }
  }

  onError(messages: string[], code: number, requestName?: string): void {
    switch (requestName) {
      // case 'updateAttachedFiles':
      // case 'createOrUpdateCompanyDocuments':
      //   this.showFileSelectionError = true;
      //   break;

      case 'approveProcessApplications':
        const errorMessage: string = messages[0] ? messages[0] : ''
        this.showErrorNotAuthZ(errorMessage)
        break

      default:
        super.onError(messages, code, requestName);
    }
  }


  private initColumns(): void {
    this.columns.push({property: 'requestStatus.description', header: 'processManagement.requestStatus', hideSorting: true} as GridColumn)
    this.columns.push({property: 'processType.description', header: 'processManagement.processType', hideSorting: true} as GridColumn)
    this.columns.push({property: 'requestSubmitDate', header: 'processManagement.requestSubmitDate', hideSorting: true} as GridColumn)
    this.columns.push({property: 'idNumber', header: 'processManagement.idNumber', hideSorting: true} as GridColumn)
    this.columns.push({property: 'memberName', header: 'processManagement.memberName', hideSorting: true} as GridColumn)
    this.columns.push({property: 'accountNumber', header: 'processManagement.accountNumber', hideSorting: true} as GridColumn)
    this.columns.push({property: 'amountNumber', header: 'processManagement.amountNumber', hideSorting: true} as GridColumn)
    this.columns.push({
      property: 'latestUpdateAttachmentDate',
      header: 'processManagement.latestUpdateAttachmentDate',
      hideSorting: true
    } as GridColumn)
    this.columns.push({property: 'userNameRouted', header: 'processManagement.userNameRouted', hideSorting: true} as GridColumn)
  }

  private initSearchFields(): void {
    // if (this.processOptions === null || this.processOptions.length === 0 ||
    //   this.allStatusType === null || this.allStatusType.length === 0 ||
    //   this.allUsers === null || this.allUsers.length === 0) {
    //   return;
    // }

    this.searchLoansFields.push({
      label: 'processManagement.processOptions',
      property: 'processOption',
      fieldType: FieldType.SELECT_FIELD,
      selectOptions: this.processOptions,
      unSelectFirst: true,
      bootstrapColumn: 3
    })
    this.searchLoansFields.push({
      label: 'processManagement.statusOptions',
      property: 'statusOptions',
      fieldType: FieldType.SELECT_FIELD,
      selectOptions: this.allStatusType,
      unSelectFirst: true,
      bootstrapColumn: 3
    })
    this.searchLoansFields.push({
      label: 'processManagement.archive',
      property: 'archive',
      fieldType: FieldType.SELECT_FIELD,
      selectOptions: this.archive,
      unSelectFirst: false,
      bootstrapColumn: 3,
      dontAddDefaultSelect: true,
      initialSelected: this.archive[1]
    })
    this.searchLoansFields.push({
      label: 'processManagement.memberId',
      property: 'memberIdNum',
      fieldType: FieldType.TEXT_FIELD,
      maxLength: 16,
      advancedOnly: false,
      bootstrapColumn: 3
    })
    this.searchLoansFields.push({
      label: 'processManagement.memberName',
      property: 'fullName',
      fieldType: FieldType.TEXT_FIELD,
      advancedOnly: true,
      bootstrapColumn: 3
    })
    this.searchLoansFields.push({
      label: 'processManagement.applicationDate',
      property: 'applicationDate',
      fieldType: FieldType.DATE_FIELD,
      bootstrapColumn: 3,
      advancedOnly: true,
    })
    this.searchLoansFields.push({
      label: 'processManagement.userNameRouted',
      property: 'userRouted',
      fieldType: FieldType.SELECT_FIELD,
      selectOptions: this.allUsers,
      unSelectFirst: true,
      advancedOnly: true,
      bootstrapColumn: 3
    })
  }

  afterManagingCompanySuccessUpdated() {
    this.isMangingCompanyStatusChanged = !this.isMangingCompanyStatusChanged;

    this.getGridData({
      ...this.searchObject
    });
    this.closeSingleRequestDetailsPopup()
    this.$emit('successResults')
  }

  private getGridData(searchObject: any): void {
    this.searchObject = searchObject;
    this.lastSearchObject = {...searchObject}

    this.fetchProcessesManagementRequest({
      requestorCallback: this,
      requestBody: {...searchObject}
    })
  }

  onExportClick(data: any) {
    this.downloadProcessesManagementApplication({
      requestorCallback: this,
      pathVariable: data.id
    })
  }

  onRowClick(res: any) {
    this.showSingleRequestDetailsPopup = true;
    this.rowSelected = res;
    this.showRemark = true;
    this.showDontSendMassage = true;
  }

  closeSingleRequestDetailsPopup() {
    this.showSingleRequestDetailsPopup = false;
    this.showRemark = false;
    this.showDontSendMassage = false;
    this.tabIndex = 0;
  }

  private showPaymentDate(): boolean {
    if (this.rowSelected.processType === undefined) {
      return false;
    }

    return this.withdrawalProcess && this.withdrawalProcess.some(value => this.rowSelected.processType.value === value)
  }

  private onCheckboxClick(checked: boolean, result: any) {
    if (!checked) {
      this.checkBoxCheckAllProperty = false;
    }

    this.showSingleRequestDetailsPopup = false

    this.gridData.forEach((row: any) => {
      if (row.id === result.id) {
        row.isCheckBoxSelected = checked;
      }
    });

    this.currentInquiries.forEach((row: any) => {
      if (row.id === result.id) {
        row.isCheckBoxSelected = checked;
      }
    })

    this.bindGridData(this.gridData)
  }

  private onCheckboxCheckAll(checkAll: boolean) {
    this.checkBoxCheckAllProperty = checkAll;

    this.gridData.forEach((row: any) => {
      row.isCheckBoxSelected = checkAll
    });

    this.bindGridData(this.gridData)
  }

  onExportGrid(exportType: ExportType, gridColumns: Array<GridColumn>, searchObject: any): void {
    let exportColumns: GridColumn[] = []
    this.exportProcessesManagementDetails({
      requestBody: {
        headerText: this.exportFileName,
        exportType: exportType,
        columnsList: exportColumns,
        searchObject: searchObject
      } as BaseRequest,
      requestorCallback: this
    })
  }

  private onAcceptToolbarButtonClicked() {
    const selectedRows: string[] = this.gridData.filter((row: any) => row.isCheckBoxSelected).map((row: any) => row.id)

    if (selectedRows.length > 0) {
      this.approveProcessRequest(selectedRows);
    }
  }

  private onShowRoutingUserPopup() {
    this.userForRoutingList = []
    this.getUsersByProcessTypeCode({
      requestorCallback: this,
      pathVariable: this.lastSearchObject.processOption.value
    })

    this.inquiriesForAssociation = this.currentInquiries.filter((row: any) => row.isCheckBoxSelected)

    if (this.inquiriesForAssociation.length === 0) {
      this.showNotSelectedInquiresPopup = true;
      return
    }

    this.showRoutingContactsToUserPopup = true;
  }

  private approveProcessRequest(allIds: string[]): void {
    this.approveProcessApplications({
      requestorCallback: this,
      requestBody: {
        memberProcessIds: allIds
      }
    })
  }

  private filterGridById(numberOfRequests: number, processOption: any) {
    this.closeSingleRequestDetailsPopup()
    this.searchObject.pageSize = numberOfRequests
    this.searchObject = {...this.searchObject, memberIdNum: this.rowSelected.idNumber, processOption: processOption}
    this.getGridData({...this.searchObject})
    this.searchObject.pageSize = this.DEFAULT_PAGE_SIZE
  }

  get exportFileName(): string {
    return '' + this.$t('processManagement.fileName')
  }

  bindGridData(data: object[]): void {
    this.$emit('successResults', {
      results: data,
      hasMore: false,
      resultCount: data.length
    });
  }

  private showSuccessAction() {
    if (!this.problemWithApplication) {
      this.$root.$emit('showAlertNotification', {
        toShow: true,
        message: 'requestManagement.popup.loanRequestUpdatedSuccessfully',
        icon: 'checkCircle',
        secondsToDisappear: 3
      })
    }
  }

  showErrorNotAuthZ(errorMessage: string) {
    this.errorMessageAfterApprove = errorMessage;
    this.problemWithApplication = true;
    this.getGridData({
      ...this.searchObject
    })
  }

  private closePopupProblem(): void {
    this.problemWithApplication = false;
  }

  private onClosePopup(): void {
    this.showRoutingContactsToUserPopup = false
    this.showNotSelectedInquiresPopup = false
  }

  private onCloseFinalStatusPopup(): void {
    this.showNotFinalStatusPopup = false
  }

  afterMemberPdfUpdated() {
    this.isMangingCompanyStatusChanged = !this.isMangingCompanyStatusChanged;
  }

  onRoutingContactsToUser() {
    if (this.inquiriesForAssociation.some((row: any) => row.finalStatus)) {
      this.onClosePopup()
      this.showNotFinalStatusPopup = true;

      this.getGridData({
        ...this.searchObject
      })
      return;
    }

    const body = {
      userToRouting: this.selectedUserForRouting,
      memberProcessIdList: this.inquiriesForAssociation.map((row: any) => row.id)
    }

    this.updateRoutingUserProcessesManagement({
      requestorCallback: this,
      requestBody: body
    })
  }

  private showAfterSuccessfullyActionPopup(message: string) {
    this.$root.$emit('showAlertNotification', {
      toShow: true,
      message: message,
      icon: 'checkCircle',
      secondsToDisappear: 3
    })
  }

  private onAddClick() {
    this.showAddingNewProcessModal = true
  }

  private onCloseAddingNewProcessModal() {
    this.showAddingNewProcessModal = false
  }
}
